<template>
<div class="page-loading">
  <p><i  class="fas fa-spinner fa-spin"></i> {{text}}</p>
</div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'loading',
    props:['text']
}
</script>


// WEBPACK FOOTER //
// src/components/elements/Loading.vue